import { useEffect, useRef, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { notificationSoundService } from '@/services/notificationSoundService';

// URL de sonido de notificación predeterminado (dominio público)
const DEFAULT_SOUND_URL = 'data:audio/wav;base64,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';

export const useNotificationSound = () => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [soundEnabled, setSoundEnabled] = useState(() => {
    const saved = localStorage.getItem('notificationSoundEnabled');
    return saved !== null ? JSON.parse(saved) : true;
  });
  const [customSoundUrl, setCustomSoundUrl] = useState<string | null>(null);
  const [isLoadingCustomSound, setIsLoadingCustomSound] = useState(false);

  // Load custom active sound on mount
  useEffect(() => {
    const loadActiveSound = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      setIsLoadingCustomSound(true);
      try {
        const activeSound = await notificationSoundService.getActiveSound(user.id);
        if (activeSound) {
          const url = await notificationSoundService.getSoundUrl(activeSound.file_path);
          setCustomSoundUrl(url);
        }
      } catch (error) {
        console.error('Error loading active sound:', error);
      } finally {
        setIsLoadingCustomSound(false);
      }
    };

    loadActiveSound();
  }, []);

  useEffect(() => {
    // Usar sonido personalizado si existe, sino el predeterminado
    const soundUrl = customSoundUrl || DEFAULT_SOUND_URL;
    
    if (!audioRef.current) {
      audioRef.current = new Audio(soundUrl);
      audioRef.current.volume = 0.5;
    } else {
      audioRef.current.src = soundUrl;
    }

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, [customSoundUrl]);

  const playSound = () => {
    if (soundEnabled && audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch(error => {
        console.error('Error playing notification sound:', error);
      });
    }
  };

  const toggleSound = () => {
    const newValue = !soundEnabled;
    setSoundEnabled(newValue);
    localStorage.setItem('notificationSoundEnabled', JSON.stringify(newValue));
  };

  const setVolume = (volume: number) => {
    if (audioRef.current) {
      audioRef.current.volume = Math.max(0, Math.min(1, volume));
    }
  };

  const refreshCustomSound = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    try {
      const activeSound = await notificationSoundService.getActiveSound(user.id);
      if (activeSound) {
        const url = await notificationSoundService.getSoundUrl(activeSound.file_path);
        setCustomSoundUrl(url);
      } else {
        setCustomSoundUrl(null);
      }
    } catch (error) {
      console.error('Error refreshing custom sound:', error);
    }
  };

  return {
    playSound,
    soundEnabled,
    toggleSound,
    setVolume,
    customSoundUrl,
    isLoadingCustomSound,
    refreshCustomSound,
  };
};
